import standardFields from "../../../../src/docs/product/discover-queries/standard-fields.json";
import * as React from 'react';
export default {
  standardFields,
  React
};